// extracted by mini-css-extract-plugin
module.exports = {"lds-ring":"Spinner_lds-ring__8sMwH"};